/**
 * The subscription verdict a manual apply is gated on: what GET api/check_purchase
 * answers (Backend.trialStatus). It is the spt backend's TrialResult, which the
 * backend gets from the BeelabX hub's apps API (spt/src/helpers/trial.ts):
 *
 *   { status: true }                    entitled
 *   { status: true, message }           entitled, operations running low (>= 80%)
 *   { status: false, message, code }    refused; `message` is the hub's customer-facing text
 *
 * `code` tells the refusals apart:
 *   'ops_limit'             the plan's operations for this period are used up
 *                           (hub reason ops_exhausted)
 *   'subscription_expired'  everything else: trial ended, cancelled, no
 *                           subscription yet, or the backend could not get a
 *                           verdict (hub credentials rejected, HUB_URL unset)
 * Backend.trialStatus's own NO_VERDICT (this app's backend did not answer) has
 * no code at all.
 */
export const OPS_LIMIT = 'ops_limit';
export const SUBSCRIPTION_EXPIRED = 'subscription_expired';

const APP_NAME = 'Subitem Pro Templates';

const base = { tone: 'danger', failures: [], notice: null, note: null };

/**
 * A refused verdict → the alert on the selected template's card
 * (components/ApplyResultAlert, same shape as lib/applyResult builds). `usage`
 * asks the alert for its "View app usage" link, which only helps when the
 * problem is the operation count.
 */
export function blockedApplyResult(templateName, verdict) {
  const name = templateName || 'the template';
  const message = verdict && typeof verdict.message === 'string' ? verdict.message.trim() : '';
  const code = verdict && verdict.code;

  if (code === OPS_LIMIT) {
    return {
      ...base,
      title: `Could not apply “${name}”: operations limit reached`,
      summary:
        message ||
        `${APP_NAME} has used all of its operations for this period. To continue, upgrade to a higher plan on the monday Marketplace or wait until the next period.`,
      usage: true,
    };
  }
  if (code === SUBSCRIPTION_EXPIRED) {
    return {
      ...base,
      title: `Could not apply “${name}”: subscription not active`,
      summary: message || `Your subscription for ${APP_NAME} is not active. Please check your plan on the monday Marketplace.`,
      usage: false,
    };
  }
  return {
    ...base,
    title: `Could not apply “${name}”: subscription not checked`,
    summary: message || 'The subscription could not be verified. Please try again shortly.',
    usage: false,
  };
}
